import { authHeader, handleUnauthorized, captureRefreshedToken } from './authToken';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const checarResposta = async (response, mensagemErro) => {
  captureRefreshedToken(response.headers);
  if (response.status === 401) {
    handleUnauthorized();
  }
  if (!response.ok) throw new Error(mensagemErro);
  return response.json();
};

export const CampeonatosService = {
  async listar() {
    const response = await fetch(`${API_URL}/campeonatos`);
    return checarResposta(response, 'Erro ao buscar campeonatos');
  },

  async buscarPorId(id) {
    const response = await fetch(`${API_URL}/campeonatos/${id}`);
    return checarResposta(response, 'Erro ao buscar campeonato');
  },

  async criar(formData) {
    const response = await fetch(`${API_URL}/campeonatos`, {
      method: 'POST',
      headers: { ...authHeader() },
      body: formData // Usa FormData nativo para suportar arquivo
    });
    return checarResposta(response, 'Erro ao criar campeonato');
  },

  async atualizar(id, formData) {
    const response = await fetch(`${API_URL}/campeonatos/${id}`, {
      method: 'PUT',
      headers: { ...authHeader() },
      body: formData
    });
    return checarResposta(response, 'Erro ao atualizar campeonato');
  },

  async remover(id) {
    const response = await fetch(`${API_URL}/campeonatos/${id}`, {
      method: 'DELETE',
      headers: { ...authHeader() },
    });
    return checarResposta(response, 'Erro ao remover campeonato');
  }
};
